module.exports = __webpack_public_path__ + "static/media/innovate.207bf756.png";